'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var prosemirrorState = require('prosemirror-state');
var prosemirrorView = require('prosemirror-view');
var index_ts = require('../consts/index.js');
var index_js = require('../utils/index.js');
var preact = require('preact');
var index_js$1 = require('../components/index.js');

const setAttributes = ($dom, attrs) => {
  Object.entries(attrs).forEach(([k, v]) => {
    $dom.setAttribute(k, v);
  });
};
function getImageAttrs(name, data, originWidth, originHeight, containerWidth, containerNode) {
  const {
    small,
    middle,
    origin
  } = data;
  const attrs = {
    border: +localStorage.getItem(index_ts.BORDER_CACHE_FIELD) === 1,
    mss: "",
    name,
    origin,
    small,
    src: middle
  };

  if (originWidth && originHeight) {
    const {
      width,
      height,
      newOriginWidth,
      newOriginHeight
    } = index_js.calculateSize(originWidth, originHeight, containerWidth, index_ts.IMAGE_MAX_HEIGHT);
    const isInTable = containerNode.tagName === "TD" || containerNode.tagName === "TH" || containerNode.tagName === "TR";
    attrs.width = isInTable ? newOriginWidth : width;
    attrs.height = isInTable ? newOriginHeight : height;
  }

  return attrs;
}

class ImageView {
  constructor(node, view, getPos, store) {
    this.dom = document.createElement("span");
    this.image = document.createElement("img");

    this.onload = () => {
      this.dom.style.height = "auto";

      try {
        if (!this.imageWidth) {
          const {
            naturalWidth,
            naturalHeight
          } = this.image;
          const containerNode = this.dom.parentElement;
          const containerWidth = containerNode.offsetWidth;
          const {
            width,
            height,
            newOriginWidth,
            newOriginHeight
          } = index_js.calculateSize(naturalWidth, naturalHeight, containerWidth);
          const containerParent = containerNode.parentElement;
          const isInTable = containerParent.tagName === "TD" || containerParent.tagName === "TH" || containerParent.tagName === "TR";
          const showWidth = isInTable ? newOriginWidth : width;
          const showHeight = isInTable ? newOriginHeight : height;
          this.imageWidth = width;
          this.store.updateAttrs({
            width: showWidth,
            height: showHeight
          }, false, this.getPos());
        }

        this.dom.removeChild(index_js.$CtLoading); // tslint:disable-next-line: no-empty
      } catch (err) {}

      this.dom.appendChild(this.image);
    };

    this.onerror = () => {
      const {
        onError
      } = this.store.config;

      if (onError && onError(this.dom)) {
        return;
      }

      if (parseInt(this.dom.style.width) < 50) {
        this.dom.style.width = "";
      }

      this.image.classList.add("ct-img-failed");
      this.dom.classList.add("failed");
    };

    const {
      name,
      border,
      link,
      width: _width,
      small,
      origin,
      height: _height
    } = node.attrs;
    const domAttrs = {
      "class": `ct-image${border ? " ct-image-border" : ""}`,
      "data-link": link
    };
    const {
      config = {}
    } = store;
    const {
      customFixDisplayUrl
    } = config;
    let src = node.attrs.src;

    if (!src) {
      // 避免src 为null时，后续报错空指针
      src = '';
      console.error('img src is empty (throw error)');
    }

    if (customFixDisplayUrl) {
      src = customFixDisplayUrl(src);
    }

    const imgAttrs = {
      "data-small": small,
      "data-origin": origin,
      alt: name.length > 100 ? `${name.substr(0, 100)}...` : name,
      src,
      width: `${_width || index_ts.IMAGE_DEFAULT_WIDTH}`
    };
    this.dom.style.width = `${_width || index_ts.IMAGE_DEFAULT_WIDTH}px`;
    this.dom.style.height = `${_height || index_ts.IMAGE_DEFAULT_HEIGHT}px`;
    setAttributes(this.dom, domAttrs);
    setAttributes(this.image, imgAttrs);
    this.store = store;
    this.getPos = getPos;
    this.imageWidth = _width;
    this.image.onerror = this.onerror;
    this.image.onload = this.onload;
    this.dom.appendChild(index_js.$CtLoading);
  }

}

const pluginKey = new prosemirrorState.PluginKey("image");
function createPlugins(store) {
  const plugin = new prosemirrorState.Plugin({
    key: pluginKey,
    state: {
      init() {
        return prosemirrorView.DecorationSet.empty;
      },

      apply(tr, set) {
        // Adjust decoration positions to changes made by the transaction
        set = set.map(tr.mapping, tr.doc); // See if the transaction adds or removes any placeholders

        const action = tr.getMeta(this);

        if (action && action.add) {
          const {
            pos,
            key
          } = action.add;
          const widget = index_js.createUploadMask();
          const deco = prosemirrorView.Decoration.widget(pos, widget, {
            key,
            size: -1
          });
          set = set.add(tr.doc, [deco]);
        } else if (action && action.remove) {
          set = set.remove(set.find(null, null, spec => spec.key === action.remove.key));
        }

        return set;
      }

    },
    props: {
      decorations(state) {
        return this.getState(state);
      },

      nodeViews: {
        image: (node, view, getPos) => new ImageView(node, view, getPos, store)
      },
      // handleDOMEvents: {
      //   drop: () => {
      //     store.hidePopover();
      //   },
      // },
      // handleClickOn: (view, pos, node, nodePos, e) => {
      //   if (node.type.name === "image") {
      //     // 设置selection
      //     const { state, dispatch } = view;
      //     const selection = NodeSelection.create(state.doc, nodePos);
      //     dispatch(state.tr.setSelection(selection));
      //     // 显示图片编辑器
      //     const dom = e.target.parentNode;
      //     if (!e.target.classList.contains("ct-img-failed")) {
      //       store.showPopover({
      //         attrs: node.attrs,
      //         dom,
      //         pos: nodePos,
      //       });
      //     }
      //     // store.rootStore.dragButtonStore.showPopover(dom, nodePos)
      //   }
      //   return false;
      // },
      handleClick: (view, pos, e) => {
        if (store.node && (store.node.pos === pos || store.node.pos + 1 === pos)) {
          return false;
        }

        const preSelected = document.querySelector('[data-type="ct-progress"].selected');

        if (preSelected) {
          preSelected.classList.remove("selected");
        } // 选中上传失败的图片


        const selected = e.target.closest('[data-type="ct-progress"]');

        if (selected) {
          const {
            state,
            dispatch
          } = view;

          if (selected.tagName.toUpperCase() === "DIV") {
            const selection = prosemirrorState.TextSelection.create(state.doc, pos, pos + 1);
            dispatch(state.tr.setSelection(selection));
          } else {
            const selection = prosemirrorState.TextSelection.create(state.doc, pos, pos + 1);
            dispatch(state.tr.setSelection(selection));
          }

          selected.classList.add("selected");
          return true;
        }
      } // handleKeyDown: (view, e) => {
      //   // 按下Command || Ctrl 键，图片编辑框不消失
      //   if (e.metaKey || e.ctrlKey) {
      //     return false;
      //   }
      //   store.hidePopover();
      //   return false;
      // },

    },
    view: view => new index_js.Popover({
      view,
      store,
      className: "ct-image-editor-popover"
    })
  });
  return [plugin];
}

const imageSchema = {
  nodes: {
    image: {
      atom: true,
      group: "inline",
      inline: true,
      draggable: true,
      allowGapCursor: true,
      braceWidth: 82,
      attrs: {
        src: {
          default: ""
        },
        // middle，为了兼容老数据所以不改了。。
        small: {
          default: ""
        },
        // 压缩比最大的，给移动端展示用
        origin: {
          default: ""
        },
        // 原图
        mss: {
          default: ""
        },
        name: {
          default: ""
        },
        width: {
          default: 0
        },
        height: {
          default: 0
        },
        link: {
          default: null
        },
        border: {
          default: false
        }
      },
      parseDOM: [{
        tag: 'span[class~="ct-image"]',

        getAttrs(dom) {
          const img = dom.querySelector("img");
          const src = img.getAttribute("data-src");
          return {
            src,
            small: img.getAttribute("data-small") || src,
            origin: img.getAttribute("data-origin") || src,
            mss: img.getAttribute("data-mss") || "",
            name: img.getAttribute("alt") || "",
            width: img.getAttribute("data-width") || 0,
            height: img.getAttribute("data-height") || 0,
            link: img.getAttribute("data-link") || null,
            border: dom.classList.contains("ct-image-border")
          };
        }

      }, {
        tag: "img",

        getAttrs(dom) {
          const src = dom.getAttribute("src");
          return {
            name: dom.getAttribute("alt") || "",
            origin: src,
            small: src,
            src,
            width: dom.getAttribute("data-width") || dom.getAttribute("width") || 0,
            height: dom.getAttribute("data-height") || dom.getAttribute("height") || 0
          };
        }

      }],

      toDOM(node) {
        const {
          mss,
          name,
          width,
          height,
          link,
          border
        } = node.attrs;
        const {
          small,
          src,
          origin
        } = node.attrs;
        const attrs = {
          class: `ct-image${border ? " ct-image-border" : ""}`
        };
        const imgAttrs = {
          "alt": name.length > 100 ? `${name.substr(0, 100)}...` : name,
          "data-origin": origin,
          "data-small": small,
          "data-src": src
        };

        if (width && width !== "0") {
          attrs.style = `width: ${width}px`;
          imgAttrs["data-width"] = width;
          imgAttrs["data-height"] = height;
        }

        if (mss) {
          imgAttrs["data-mss"] = mss;
        }

        if (link) {
          imgAttrs["data-link"] = link;
        }

        return ["span", attrs, ["img", imgAttrs]];
      }

    }
  }
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty;

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

var objectSpread = _objectSpread;

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".ct-image-link-modal .content{height:206px!important}.ct-image-link-modal .ant-modal-footer{padding:0 24px 32px;border:none}.ct-image-link-modal .ant-modal-footer .ant-btn{width:60px!important;height:32px;padding:0;margin-left:16px;border-radius:2px}.ct-image-link-modal .input-error{position:absolute;top:55px;left:65px;font-size:12px;color:#f05e50}.image-link-content{padding:14px 0;position:relative;font-size:12px;color:rgba(0,0,0,.65)}.image-link-content .cte-image-link-modal-item{color:rgba(0,0,0,.6);line-heigt:22px}.image-link-content .cte-image-link-modal-item>label{display:flex;align-items:center}.image-link-content .cte-image-link-modal-item>label span{color:rgba(0,0,0,.6);width:60px}.image-link-content .cte-image-link-modal-item input[type=text]{width:100%;height:32px;padding:6px 8px;margin-left:12px;border-radius:4px;border:1px solid rgba(0,0,0,.13);outline:none;color:rgba(0,0,0,.87);transition:all .218s ease}.image-link-content .cte-image-link-modal-item input[type=text]:focus{border:1px solid #1c6cdc}.image-link-content .cte-image-link-modal-item input[type=text]::-webkit-input-placeholder{color:rgba(0,0,0,.24)}.image-link-content .cte-image-link-modal-item input[type=text]::-moz-placeholder{color:rgba(0,0,0,.24)}.image-link-content .cte-image-link-modal-item input[type=text]::-ms-input-placeholder{color:rgba(0,0,0,.24)}.image-link-content .cte-image-link-modal-item input[type=text]:-ms-input-placeholder{color:rgba(0,0,0,.24)}.image-link-content .cte-image-link-modal-item input[type=text]::placeholder{color:rgba(0,0,0,.24)}";
styleInject(css);

const formatLink = href => {
  const regex1 = /^(https?:\/\/)?(\w+\.?)+(\/.+)?$/i;
  const regex2 = /^((https?:\/\/|\w+(\.\w+)+)(:\w+)?).+$/;
  const newHref = href.replace(regex1, (match, capture) => capture ? match : `http://${match}`); // eslint-disable-line

  return regex2.test(newHref) ? newHref : false;
};

class LinkModal extends preact.Component {
  constructor(props) {
    super();
    this.link = '';
    this.state = {
      error: null
    };

    this.handleKeydown = e => {
      // ENTER
      if (e.which === 13 || e.keyCode === 13) {
        this.handleOk();
        e.stopPropagation();
        e.preventDefault();
        return false;
      }
    };

    this.handleInputHref = e => {
      if (this.state.error) {
        this.setState({
          error: null
        });
      }

      this.link = e.target.value.replace(/(^[\u200B\s])|([\u200B\s]$)/g, '');
    };

    this.handleOk = () => {
      const link = formatLink(this.link);
      if (!link) return this.setState({
        error: '请输入正确的地址'
      });
      this.handleCancel();
      this.props.addImageLink(link);
    };

    this.handleCancel = () => {
      if (this.state.error) this.setState({
        error: null
      });
      this.props.closeModal();
    };

    this.link = props.link || '';
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeydown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeydown);
  }

  render() {
    const {
      link = ''
    } = this.props;
    const {
      error
    } = this.state;
    return preact.h(index_js$1.Modal, {
      visible: true,
      className: "ct-image-link-modal",
      title: "\u56FE\u7247\u94FE\u63A5",
      okText: "\u63D2\u5165",
      onOk: this.handleOk,
      onCancel: this.handleCancel,
      canEnter: true
    }, preact.h("div", {
      className: "image-link-content"
    }, preact.h("div", {
      className: "cte-image-link-modal-item"
    }, preact.h("label", null, preact.h("span", null, "\u94FE\u63A5\u5730\u5740"), preact.h("input", {
      id: "imagelink",
      type: "text",
      className: "ct-input input-link-href",
      placeholder: "\u8BF7\u8F93\u5165\u94FE\u63A5\u5730\u5740",
      autoComplete: "off",
      defaultValue: link,
      onInput: this.handleInputHref
    }))), error && preact.h("div", {
      className: "input-error"
    }, error)));
  }

}

var css$1 = ".ct-image-toolbar{display:flex;height:34px;padding:0 10px;opacity:1;transition:opacity .2s ease}.ct-image-toolbar .split{width:1px;height:14px;margin-top:0;background:#d8d8d8}.ct-image-toolbar .pm-image-width-label{height:18px;padding-left:8px;margin-top:0;color:#333;font-size:12px;line-height:20px}.ct-image-toolbar .pm-image-width-input{border-radius:2px;border:1px solid #ddd;box-sizing:border-box;width:66px;height:24px;padding:5px 8px 3px;margin:0 0 0 8px;font-size:12px;color:#333;-moz-appearance:textfield}.ct-image-toolbar .pm-image-width-input::-webkit-inner-spin-button,.ct-image-toolbar .pm-image-width-input::-webkit-outer-spin-button{-webkit-appearance:none!important;margin:0}.ct-toolbar-tooltip{position:absolute;left:50%;-webkit-transform:translate(-50%);transform:translate(-50%);bottom:-35px;height:25px;padding:0 10px;line-height:25px;white-space:nowrap;vertical-align:middle;color:#fff;font-size:12px;background:rgba(0,0,0,.7);border-radius:4px;z-index:1}.ct-toolbar-tooltip:after{position:absolute;width:0;top:-5px;right:50%;-webkit-transform:translate(50%);transform:translate(50%);display:block;border-color:rgba(0,0,0,.7) transparent;border-style:solid;border-width:0 5px 5px;content:\"\";z-index:1}";
styleInject(css$1);

class Toolbar extends preact.Component {
  constructor(props) {
    super(props);
    this.container = null;
    this.input = null;

    this.handleCheckboxChange = () => {
      const newHasBorder = !this.state.hasBorder;
      this.setState({
        hasBorder: newHasBorder
      });
      this.props.toggleBorder(newHasBorder);
    };

    this.addLink = () => {
      this.setState({
        visible: true
      });
    };

    this.editLink = () => {
      this.setState({
        visible: true
      });
    };

    this.cancelLink = () => {
      this.props.cancelImageLink();
    };

    this.closeModal = () => {
      this.setState({
        visible: false
      });
    };

    this.handleInputChange = e => {
      const width = e.target.value;
      this.setState({
        width
      });
    };

    this.setWidth = () => {
      const {
        maxWidth,
        naturalWidth
      } = this.props;
      let width = this.input.value;

      if (width < index_ts.IMAGE_MIN_WIDTH) {
        if (naturalWidth < 5 || naturalWidth > index_ts.IMAGE_MIN_WIDTH) {
          width = index_ts.IMAGE_MIN_WIDTH;
        } else if (width < naturalWidth) {
          width = naturalWidth;
        }
      } else if (width > maxWidth) {
        width = maxWidth;
      }

      this.props.setWidth(width);

      if (width !== this.state.width) {
        this.setState({
          width
        });
      }
    };

    this.state = {
      hasBorder: props.hasBorder,
      hasLink: !!props.link,
      visible: false,
      width: props.width
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      hasLink: !!nextProps.link
    });
  }

  render() {
    const {
      hasBorder,
      hasLink,
      visible,
      width
    } = this.state;
    return preact.h("div", {
      ref: r => this.container = r,
      className: "ct-image-toolbar"
    }, preact.h(index_js$1.CheckBox, {
      checked: hasBorder,
      onClick: this.handleCheckboxChange
    }, "\u8FB9\u6846"), preact.h("div", {
      className: "split"
    }), hasLink ? [preact.h(index_js$1.IconItem, {
      type: "cancelLink",
      onClick: this.cancelLink,
      tip: "\u53D6\u6D88\u94FE\u63A5"
    }), preact.h(index_js$1.IconItem, {
      type: "edit",
      onClick: this.editLink,
      tip: "\u7F16\u8F91\u94FE\u63A5"
    })] : preact.h(index_js$1.IconItem, {
      type: "link",
      onClick: this.addLink,
      tip: "\u94FE\u63A5"
    }), preact.h("div", {
      className: "split"
    }), preact.h("label", {
      id: "pm-image-width-label",
      className: "pm-image-width-label",
      htmlFor: "pm-image-width-input"
    }, "\u5BBD\u5EA6"), preact.h("input", {
      id: "pm-image-width-input",
      ref: i => this.input = i,
      className: "ct-input pm-image-width-input",
      type: "number",
      autoComplete: "off",
      value: parseInt(width, 10),
      onChange: this.handleInputChange,
      onBlur: this.setWidth,
      onKeyDown: e => {
        if (e.keyCode === 13) {
          e.target.blur();
        }
      }
    }), visible && preact.h(LinkModal, {
      link: this.props.link,
      addImageLink: this.props.addImageLink,
      closeModal: this.closeModal
    }));
  }

}

const getToolBar = (node, update) => {
  const {
    dom,
    attrs
  } = node;
  const {
    width
  } = dom.getBoundingClientRect();
  const blockNode = index_js.findParentBlockNode(node.dom);

  if (!blockNode) {
    return;
  }

  const parentTagName = blockNode.parentNode.tagName.toLowerCase();
  let maxWidth = blockNode.clientWidth - index_ts.IMAGE_OFFSET;

  if ((parentTagName === "td" || parentTagName === "th") && blockNode.closest("table").classList.contains("responsive")) {
    maxWidth = 1920;
  }

  return preact.h(Toolbar, {
    dom: dom,
    type: "image",
    link: attrs.link,
    width: attrs.width || width,
    maxWidth: maxWidth,
    naturalWidth: dom.firstChild.naturalWidth,
    hasBorder: dom.classList.contains("ct-image-border"),
    toggleBorder: data => toggleBorder(data, update),
    addImageLink: data => addImageLink(data, update),
    cancelImageLink: () => cancelImageLink(update),
    setWidth: width => setWidth(node, width, update)
  });
}; // 新增图片链接

const addImageLink = (link, update) => {
  update({
    link
  });
}; // 取消图片链接

const cancelImageLink = update => {
  update({
    link: null
  });
}; // 切换边框

const toggleBorder = (hasBorder, update) => {
  localStorage.setItem(index_ts.BORDER_CACHE_FIELD, hasBorder ? "1" : "0");
  update({
    border: hasBorder
  });
}; // 设置宽度

const setWidth = (node, width, update) => {
  const dom = node.dom;
  const $img = dom.querySelector("img");
  const height = width / $img.clientWidth * $img.clientHeight;
  dom.style.width = `${width}px`;
  update({
    width,
    height
  });
};

const preloadImage = src => new Promise((resolve, reject) => {
  const image = new Image(); // 兼容 safari 和 firefox

  setTimeout(() => {
    setTimeout(() => {
      image.src = src;
    }, 0);
  }, 0);

  image.onload = () => resolve(image);

  image.onerror = () => reject(`图片下载失败: ${src}`);
});

var _class, _temp;
let ImageStore = index_js.uploader(_class = index_js.resizer(_class = (_temp = class ImageStore {
  constructor() {
    this.pluginName = "image$";
    this.view = void 0;
    this.trigger = void 0;
    this.config = void 0;
    this.node = void 0;
    this.ctPopover = void 0;
    this.editor = void 0;
  }

  init(editor) {
    const {
      trigger,
      view,
      imageConfig = {}
    } = editor;
    this.trigger = trigger;
    this.view = view;
    this.config = imageConfig;
    this.editor = editor;
  }

  insertToDoc(key, filename, failedHandle) {
    return async ({
      name = filename,
      src,
      width: w,
      small,
      origin
    }) => {
      try {
        if (!src) {
          throw new Error("图片上传失败");
        }

        const {
          customFixDisplayUrl
        } = this.config;

        if (customFixDisplayUrl) {
          src = customFixDisplayUrl(src);
        }

        const {
          naturalWidth,
          naturalHeight
        } = await preloadImage(src);
        const {
          dispatch
        } = this.view;
        const placeHolderInfo = index_js.findPlaceholder(this.view, this.pluginName, key);

        if (!placeHolderInfo) {
          return;
        }

        const {
          node,
          pos
        } = placeHolderInfo;
        const $container = index_js.findParentBlockNode(node);
        const containerWidth = ($container && $container.clientWidth !== 0 ? $container.clientWidth : 68) - index_ts.IMAGE_OFFSET;
        const attrs = getImageAttrs(name, {
          small,
          middle: src,
          origin
        }, naturalWidth, naturalHeight, containerWidth, $container && $container.parentNode);

        if (w) {
          // @ts-ignore
          attrs.height = w * naturalHeight / naturalWidth; // @ts-ignore

          attrs.width = w;
        }

        dispatch(this.view.state.tr.replaceWith(pos, pos, this.view.state.schema.nodes.image.create(attrs)));
        index_js.deletePlaceholder(this.view, this.pluginName, key);
      } catch (e) {
        console.error(e);
        failedHandle("图片上传失败");
      }
    };
  }

  updateAttrs(data, shouldSelect = true, pos) {
    const {
      state,
      dispatch
    } = this.view;
    const {
      tr,
      doc,
      schema
    } = state;

    if (pos === undefined) {
      pos = this.node.pos;
    }

    const ctrlNode = tr.doc.nodeAt(pos);

    if (!ctrlNode) {
      return;
    }

    const attrs = objectSpread({}, ctrlNode.attrs, data);

    tr.setNodeMarkup(pos, schema.nodes.image, attrs);

    if (shouldSelect) {
      const newSelection = prosemirrorState.NodeSelection.create(doc, pos);
      tr.setSelection(newSelection);
    }

    dispatch(tr);

    if (shouldSelect) {
      const dom = this.view.nodeDOM(pos);

      if (dom) {
        this.showPopover({
          dom,
          attrs,
          pos
        });
      }
    }
  }

  showPopover(node) {
    this.hidePopover();
    this.node = node;
    this.ctShowResizer();
    this.ctPopover.show({
      dom: node.dom,
      content: getToolBar(node, this.updateAttrs.bind(this))
    });
  }

  hidePopover() {
    this.ctHideResizer();
    this.ctPopover.hide();
  } // public handleViewUpdate({ view, selNode, selection }: any) {
  //   if (selNode && selNode.type.name === "image") {
  //     const domNode = view.docView.domFromPos(selection.from).node;
  //     const imageDoms = domNode.querySelectorAll("img");
  //     if (imageDoms.length !== 1) { return; }
  //     this.showPopover({
  //       dom: imageDoms[0].parentNode,
  //       attrs: selNode.attrs,
  //       pos: selection.from,
  //     });
  //   } else {
  //     this.hidePopover();
  //   }
  // }


}, _temp)) || _class) || _class;

const readeAsBase64 = (file, onprogress) => new Promise((resolve, reject) => {
  const reader = new FileReader();

  reader.onload = () => resolve(reader.result);

  reader.onerror = () => reject("oops");

  reader.onprogress = onprogress;
  reader.readAsDataURL(file);
});

const customUpload = async ({
  file,
  onprogress,
  insert,
  failedHandle
}) => {
  try {
    const result = await new Promise(res => {
      setTimeout(async () => {
        const rest = await readeAsBase64(file, onprogress);
        res(rest);
      }, 2000);
    });
    await insert({
      src: result
    });
  } catch (e) {
    failedHandle(`some errors: ${e}`);
  }
};

const config = {
  customUpload
};

var css$2 = ".ct-image{display:inline-block;position:relative;max-width:100%;margin:0 3px;line-height:1;font-size:0;box-sizing:content-box;background-color:#fff;vertical-align:bottom}.ct-image.ProseMirror-selectednode{outline:2px solid #00a7cd}.ct-image img{width:100%;max-width:100%;vertical-align:bottom}.ct-image .ct-img-failed{min-width:50px;min-height:50px}.ct-image .ct-img-failed,.ct-image .ct-img-loading,.ct-image .ct-img-mask{display:inline-block}.ct-image .ct-img-failed:before,.ct-image .ct-img-loading:before,.ct-image .ct-img-mask:before{content:\"\";position:absolute;left:0;top:0;display:block;width:100%;height:100%;background:#f6f6f6;z-index:1}.ct-image .ct-img-failed:after,.ct-image .ct-img-loading:after,.ct-image .ct-img-mask:after{content:\"\";position:absolute;left:12px;top:12px;display:block;width:28px;height:20px;z-index:2}.ct-image .ct-img-noperm{position:absolute;left:12px;top:40px;display:block;z-index:9;font-size:14px;color:#777}.ct-image .ct-img-failed:after{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1380 1024' xmlns='http://www.w3.org/2000/svg' width='26.953' height='20'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M526.889 315.732l165.016 171.024a66.785 66.785 0 0 1 18.724 46.371V737.77l135.664-202.254-123.399-162.635a66.78 66.78 0 0 1-8.027-67.029L830.58 40.121C841.19 15.756 865.235.001 891.809.001h338.475c82.394 0 149.89 65.742 149.89 147.731V876.27c0 81.989-67.496 147.731-149.89 147.731H149.89C67.496 1024.001 0 958.259 0 876.27V147.732C0 65.743 67.496.001 149.89.001h393.258c45.99 0 78.216 45.4 63.044 88.815L526.89 315.733z' fill='%237F9496'/%3E%3Cpath d='M543.148 66.783l-83.824 239.855a44.52 44.52 0 0 0 9.99 45.602l174.532 180.887v277.792a44.52 44.52 0 0 0 19.721 36.974c20.42 13.697 48.078 8.247 61.775-12.173l185.264-276.199c10.592-15.791 9.987-36.565-1.506-51.712L776.096 332.515 891.809 66.784h338.475c45.899 0 83.107 36.242 83.107 80.949v728.538c0 44.707-37.208 80.949-83.107 80.949H149.89c-45.899 0-83.107-36.242-83.107-80.949V147.733c0-44.707 37.208-80.949 83.107-80.949h393.258z' fill='%23FFF'/%3E%3Cpath d='M496.955 289.391l252.816 398.046 196.047-178.035 300.791 358.771H133.566z' fill='%23DDD'/%3E%3Cpath d='M526.889 315.732l165.016 171.024a66.785 66.785 0 0 1 18.724 46.371V737.77l135.664-202.254-123.399-162.635a66.78 66.78 0 0 1-8.027-67.029L830.58 40.121C841.19 15.756 865.235.001 891.809.001h338.475c82.394 0 149.89 65.742 149.89 147.731V876.27c0 81.989-67.496 147.731-149.89 147.731H149.89C67.496 1024.001 0 958.259 0 876.27V147.732C0 65.743 67.496.001 149.89.001h393.258c45.99 0 78.216 45.4 63.044 88.815L526.89 315.733zm16.259-248.949H149.89c-45.899 0-83.107 36.242-83.107 80.949V876.27c0 44.707 37.208 80.949 83.107 80.949h1080.394c45.899 0 83.107-36.242 83.107-80.949V147.732c0-44.707-37.208-80.949-83.107-80.949H891.809L776.096 332.514 909.1 507.808c11.493 15.147 12.098 35.922 1.506 51.712L725.342 835.719c-13.697 20.42-41.355 25.871-61.775 12.173a44.522 44.522 0 0 1-19.721-36.974V533.126L469.314 352.239a44.523 44.523 0 0 1-9.99-45.602l83.824-239.855z' fill='%237F9496'/%3E%3Cpath d='M1230.284 309.628c0 67.06-55.813 121.423-124.661 121.423s-124.661-54.363-124.661-121.423 55.813-121.423 124.661-121.423 124.661 54.363 124.661 121.423z' fill='%23EEE'/%3E%3C/svg%3E\") no-repeat 0 0}.ct-image .ct-img-mask:after{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1380 1024' xmlns='http://www.w3.org/2000/svg' width='26.953' height='20'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M155.826 0h1068.522c86.06 0 155.826 69.766 155.826 155.826v712.348c0 86.06-69.766 155.826-155.826 155.826H155.826C69.766 1024 0 954.234 0 868.174V155.826C0 69.766 69.766 0 155.826 0z' fill='%237F9496'/%3E%3Cpath d='M155.826 66.783c-49.177 0-89.043 39.866-89.043 89.043v712.348c0 49.177 39.866 89.043 89.043 89.043h1068.522c49.177 0 89.043-39.866 89.043-89.043V155.826c0-49.177-39.866-89.043-89.043-89.043H155.826z' fill='%23FFF'/%3E%3Cpath d='M496.955 289.391l252.816 398.046 196.047-178.035 300.791 358.771H133.566z' fill='%23D6D2ED'/%3E%3Cpath d='M1230.284 309.628c0 67.06-55.813 121.423-124.661 121.423s-124.661-54.363-124.661-121.423 55.813-121.423 124.661-121.423 124.661 54.363 124.661 121.423z' fill='%23E8E4FB'/%3E%3C/svg%3E\") no-repeat 0 0}.ct-image .ct-img-loading-bounce{position:absolute;display:block;z-index:9}.ct-image .ct-img-loading-bounce>i{display:none;vertical-align:middle}.ct-image .ct-img-loading-bounce>:nth-child(-n+3){display:inline-block;width:12px;height:12px;background:$brand;border-radius:50%;-webkit-animation:bounce-delay 1.4s ease-in-out infinite both;animation:bounce-delay 1.4s ease-in-out infinite both}.ct-image .ct-img-loading-bounce>:nth-child(-n+3):not(:last-child){margin-right:5px}.ct-image .ct-img-loading-bounce>:first-child{-webkit-animation-delay:-.32s;animation-delay:-.32s}.ct-image .ct-img-loading-bounce>:nth-child(2){-webkit-animation-delay:-.16s;animation-delay:-.16s}.ct-image.ProseMirror-selectednode{outline:2px solid $brand!important}.ct-image-border{display:inline-block;outline:2px solid #ddd!important}.ct-edit-img>img{display:block;max-width:100%;border:1px solid transparent}.ct-edit-img.active>img{border:1px solid #118bfb}span[data-type=ct-progress]{min-width:62px;min-height:62px}span[data-type=ct-progress].selected{outline:2px solid #118bfb}span[data-type=ct-progress] ::-moz-selection{background:transparent!important;color:unset!important}span[data-type=ct-progress] ::selection{background:transparent!important;color:unset!important}span[data-type=ct-progress] img{width:auto;max-width:100%;max-height:600px}.ct-image-editor{display:block;position:absolute;left:0;right:0;top:0;bottom:0;z-index:11;outline:1px dashed #aaa;pointer-events:none}.ct-image-editor .resizer{position:absolute;width:24px;height:24px;pointer-events:auto}.ct-image-editor .resizer:after{box-sizing:border-box;content:\" \";position:absolute;display:block;top:5px;left:5px;width:14px;height:14px;border-radius:7px;border:2px solid #fff;box-shadow:0 1px 2px 0;background-color:#333}.ct-image-editor .info{position:absolute;padding:5px;font-size:12px;color:#fff;background:rgba(0,0,0,.7)}.ct-image-editor .info-lt{left:8px;top:8px}.ct-image-editor .info-lb{left:8px;bottom:8px}.ct-image-editor .info-rt{right:8px;top:8px}.ct-image-editor .info-rb{right:8px;bottom:8px}.ct-image-editor .resizer-lt{left:-12px;top:-12px;cursor:nwse-resize}.ct-image-editor .resizer-lb{left:-12px;bottom:-12px;cursor:nesw-resize}.ct-image-editor .resizer-rt{right:-12px;top:-12px;cursor:nesw-resize}.ct-image-editor .resizer-rb{right:-12px;bottom:-12px;cursor:nwse-resize}.ct-image-resizer{display:none;position:absolute;height:24px;width:24px;z-index:11}.ct-image-mask.image{position:absolute;top:-1px;left:-1px;bottom:-1px;right:-1px;min-width:360px;min-height:100px;font-size:14px;overflow:hidden;background:rgba(0,0,0,.7);color:#fff}.ct-image-mask.image .ct-image-loading{position:absolute;top:10px;left:10px;width:15px;height:15px;border-radius:50%;border:2px solid #d5d5d5;border-bottom-color:transparent;vertical-align:-8%;-webkit-animation:image-loading .8s linear infinite;animation:image-loading .8s linear infinite}.ct-image-mask.image .ct-image-progress{position:absolute;top:30px;left:10px;text-decoration:none!important}.ct-image-mask.image .ct-image-load-failed{top:7px;line-height:20px;overflow:hidden;color:#fff}.ct-image-mask.image .ct-image-load-failed,.ct-image-mask.image .ct-image-reupload{display:none;position:absolute;left:7px;font-size:12px;text-decoration:none!important}.ct-image-mask.image .ct-image-reupload{top:70px;padding:2px;border-radius:2px;color:#000;background:#fff;outline:none;cursor:pointer}@-webkit-keyframes image-loading{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes image-loading{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}";
styleInject(css$2);

function isContainsByTags(node, tags) {
  let parentNode = node.parentNode;

  while (parentNode && parentNode.id !== 'pm-body-wrapper') {
    if (tags.includes((parentNode.tagName || '').toLowerCase())) {
      return parentNode;
    }

    parentNode = parentNode.parentNode;
  }

  return false;
} // 加默认图及站位


function handleAddImgSpace(imgs, maxWidth) {
  Array.from(imgs).forEach(img => {
    const imgSource = img.getAttribute('data-src');
    if (!imgSource || img.getAttribute('src')) return;
    const dataWidth = img.getAttribute('data-width');
    const dataHeight = img.getAttribute('data-height');

    if (!dataWidth || !dataHeight) {
      img.src = imgSource;
      img.style.maxWidth = '100%';
      img.parentNode.style.cssText = 'max-width: 100%';
      return;
    }

    img.className = 'ct-img-mask';
    const parentNodeWithTable = isContainsByTags(img, ['td', 'th']);

    if (parentNodeWithTable) {
      img.parentNode.style.cssText = `max-width: 100%; width: ${dataWidth}px`;
      img.height = dataHeight;
      return;
    }

    if (dataWidth < maxWidth) {
      img.width = dataWidth;
      img.height = dataHeight;
      img.parentNode.style.cssText = `width: ${dataWidth}px`;
    } else {
      img.width = '100%';
      img.height = dataHeight * (maxWidth / dataWidth);
      img.parentNode.style.cssText = 'width: 100%';
    }
  });
} // 设置所有图片src （无需懒加载时候使用）

function setImgsSrc(imgs, maxWidth, onError) {
  Array.from(imgs).forEach(img => {
    if (!img.hasAttribute('data-src')) return;
    const dataWidth = img.getAttribute('data-width');
    const parentNodeWithTable = isContainsByTags(img, ['td', 'th']);

    if (parentNodeWithTable || !dataWidth) {
      img.parentNode.style.cssText = `max-width: ${dataWidth}px`;
    }

    if (dataWidth < maxWidth) {
      img.width = dataWidth;
      img.parentNode.style.cssText = `width: ${dataWidth}px`;
    } else {
      img.width = '100%';
      img.parentNode.style.cssText = 'width: 100%;';
    }

    img.src = img.getAttribute('data-src');

    img.onerror = e => {
      if (onError(e)) {
        e.target.classList.add('ct-img-failed');
      }
    };
  });
}

const handleImageLink = $body => {
  const handler = ({
    target
  }) => {
    const $span = target.closest('.ct-image');

    if ($span && target.getAttribute('data-link')) {
      window.open(target.getAttribute('data-link'));
    }
  };

  $body.addEventListener('click', handler);
  return () => $body.removeEventListener('click', handler);
};

const imageToView = ({
  bodyWrapper,
  onDestroy
}, {
  maxWidth = 1000,
  lazyload = false,
  imageLink = true,
  onError = () => true
} = {}) => {
  const imgs = bodyWrapper.querySelectorAll('.ct-image > img');
  if (!imgs.length) return;
  if (imageLink) onDestroy(handleImageLink(bodyWrapper));

  if (!lazyload) {
    setImgsSrc(imgs, maxWidth, onError);
  } else {
    handleAddImgSpace(imgs, maxWidth);
  }
};

class ImageModule {
  constructor() {
    this.name = "image";
    this.schema = void 0;
    this.plugins = void 0;
    this.config = void 0;
    this.store = void 0;
    this.editor = void 0;
    this.store = new ImageStore();
    this.schema = imageSchema;
    this.plugins = [...createPlugins(this.store)];
    this.config = config;
  }

  init(editor) {
    this.editor = editor;
    this.store.init(editor);
  }

}
ImageModule.moduleName = "image";

exports.ImageModule = ImageModule;
exports.imageToView = imageToView;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/@mtfe/citadel-editor/lib/image/index.js